import { css } from '@linaria/core';
import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

export const HeaderLinksWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	grid-area: center;
	gap: 16px;
`;

export const HeaderLink = styled(Link)`
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 125%;
	position: relative;
	letter-spacing: -0.32px;
	color: var(--color-white-05);
	transition: color 0.2s ease;
	user-select: none;
	touch-action: none;
	text-align: center;
	padding-top: 10px;
	padding-bottom: 10px;
	&.active {
		pointer-events: none;
		color: var(--color-white);
		span {
			&:after {
				transform: none;
			}
		}
	}

	&:not(.active):hover {
		color: var(--color-white-07);

		span:after {
			transform-origin: left center;
			right: auto;
			left: 0;
			transform: none;
		}
	}

	span {
		position: relative;
		white-space: nowrap;

		&:after {
			content: '';
			height: 2px;
			width: 100%;
			background: var(--bot-color-main);
			position: absolute;
			bottom: -9px;
			right: 0;
			transform: scaleX(0);
			transform-origin: right center;
			transition: transform 0.3s ease-in-out;
		}
	}
`;

export const unreadMessagesClass = css`
	position: absolute;
	top: -2px;
	right: -17px;
`;
